import BlogsLayout from "@/components/layout/BlogsLayout";
import Grid from "@mui/material/Grid2";
import styles from "@/styles/blogs/blogs.module.scss";
import { useEffect, useRef, useState } from "react";
import { Box, MenuItem, Select, Stack, useMediaQuery } from "@mui/material";
import Head from "next/head";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { blogListRedux } from "@/app/store/blog-list/reducers";
import CircularProgress from "@mui/material/CircularProgress";
import CustomLoader from "@/components/common/CustomLoader/CustomLoader";
import dynamic from "next/dynamic";
import { DateFormatter } from "@/utils/DateFormatter";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { blogHeaderRedux } from "@/app/store/blog-header/reducers";
const CustomCarousel = dynamic(
  () => import("@/components/custom-carousel/CustomCarousel"),
  { ssr: false },
);

const CustomChip = dynamic(
  () => import("@/components/custom-chip/CustomChip"),
  { ssr: false },
);

const blogPageSize = 6;

const Blogs = () => {
  const isSmallScreen = useMediaQuery("(max-width: 767px)");
  const blogList = useSelector((state) => state?.blogList?.blogList?.blogs);
  const blogListPagination = useSelector(
    (state) => state?.blogList?.blogList?.blogs_connection?.pageInfo,
  );
  const blogListForHeader = useSelector(
    (state) => state?.blogList?.blogListHeader?.blogs,
  );
  const isBlogListLoading = useSelector((state) => state?.blogList?.isLoading);
  const blogsListByCategory = useSelector(
    (state) => state?.blogList?.blogListByCategory,
  );
  const isBlogHeaderListLoading = useSelector(
    (state) => state?.blogList?.isBlogHeaderListLoading,
  );

  const dispatch = useDispatch();
  const router = useRouter();

  const fetchBlogList = (data) =>
    dispatch(blogListRedux.actions.getBlogListRequest(data));

  const fetchBlogsByCategory = (data) =>
    dispatch(blogListRedux.actions.getBlogListByCategoryRequest(data));

  const fetchBlogsForHeader = (data) =>
    dispatch(blogListRedux.actions.getBlogListForHeaderRequest(data));

  const fetchBlogsForUpdates = (data) =>
    dispatch(blogListRedux.actions.getBlogListForUpdatesRequest(data));

  const fetchBlogHeaders = (data) => {
    dispatch(blogHeaderRedux.actions.getBlogHeaderRequest(data));
  };

  const [selectedCategory, setSelectedCategory] = useState("All");
  const [filterBy, setFilterBy] = useState("Recent");
  const [updatesCurrentPage, setUpdatesCurrentPage] = useState(1);
  const [currentBlogPage, setCurrentBlogPage] = useState(1);

  const [blogListPageSize, setBlogListPageSize] = useState(blogPageSize);
  const blogListScrollRef = useRef();

  const headerText = useSelector(
    (state) => state?.blogHeader?.blogHeader?.headerText,
  );

  const configureHeaderText = (str) => {
    let words = str.match(/[^,\s]+,?|&|[^&\s]+/g);

    for (let i = 1; i < words.length; i++) {
      if (words[i] === "&") {
        words[i - 1] += " &";
        words.splice(i, 1);
      }
    }

    return words;
  };

  useEffect(() => {
    // TODO : For now this call is not required
    fetchBlogsByCategory({ categorySlug: "" });
    fetchBlogHeaders({});
    fetchBlogsForHeader({});
  }, []);

  // TODO : For now this call is not required
  // useEffect(() => {
  //   fetchBlogsForUpdates({
  //     page: updatesCurrentPage,
  //     pageSize: updatesPageSize,
  //   });
  // }, []);

  useEffect(() => {
    fetchBlogList({
      categoryName: selectedCategory === "All" ? "" : selectedCategory,
      filterBy,
      page: currentBlogPage,
      pageSize: blogListPageSize,
    });
  }, [selectedCategory, filterBy, blogListPageSize]);

  const handleNavigateToDetails = (slug) => {
    router.push(`/${slug}`);
  };

  let headerData = blogListForHeader?.map((item) => ({
    media: isSmallScreen ? item?.mobile_media : item?.media,
    title: item?.title,
    description: item?.short_description,
    slug: item?.slug,
    author:
      !!item?.author?.name &&
      item?.publishedAt &&
      `${item?.author?.name} ${
        item?.publishedAt && ` / ${DateFormatter(item?.publishedAt)}`
      } `,
  }));

  const handleViewLessBlogs = () => {
    setBlogListPageSize(blogPageSize);
    setTimeout(() => {
      blogListScrollRef.current.scrollIntoView({ behavior: "smooth" });
    }, 500);
  };

  return (
    <BlogsLayout>
      <Head>
        <title>Simple Energy | Blogs</title>
        <meta name="description" content="Blogs" />
        <meta name="keywords" content="Blogs" />
      </Head>

      {isBlogHeaderListLoading ? (
        <CustomLoader />
      ) : (
        <>
          <div className={styles.headerWrapper}>
            <div className={styles.headerSection}>
              <div className={styles.headerTextContent}>
                <h3 className={styles.titleText}>
                  {headerText?.title || "Simple blogs"}
                </h3>
                {headerText?.headerText &&
                  configureHeaderText(headerText?.headerText)?.map(
                    (text, index) => (
                      <h3 key={index} className={styles.headingText}>
                        {text}
                      </h3>
                    ),
                  )}
              </div>

              {headerData?.length > 0 ? (
                <div className={styles.carouselSection}>
                  <CustomCarousel data={headerData} />
                </div>
              ) : null}
            </div>
          </div>

          {/* Blogs List */}
          <div className={styles.bloglistWrapper}>
            <div className={styles.bloglistContent}>
              <h1>All Blogs</h1>

              <div className={styles.blogsListing}>
                {blogsListByCategory?.length > 0 ? (
                  <Grid
                    container
                    spacing={3}
                    sx={{
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      mb={3}
                      size={{ sm: 6, md: 8, lg: 8 }}
                      sx={{
                        maskImage:
                          "linear-gradient(to right, rgb(13, 12, 12) 70%, rgba(10, 6, 6, 0.6) 80%, transparent 100%)",
                        paddingRight: "10px",
                      }}
                    >
                      <div className={styles.categoriesSection}>
                        <CustomChip
                          title={"All"}
                          isSelected={selectedCategory === "All"}
                          onClick={() => setSelectedCategory("All")}
                        />
                        {blogsListByCategory?.map((category, index) => (
                          <Box
                            key={index}
                            mr={
                              index === blogsListByCategory?.length - 1 ? 10 : 0
                            }
                          >
                            <CustomChip
                              key={index}
                              title={category?.name}
                              isSelected={category?.name === selectedCategory}
                              onClick={() =>
                                setSelectedCategory(category?.name)
                              }
                            />
                          </Box>
                        ))}
                      </div>
                      <div className={styles.categorySelection}>
                        <Select
                          variant="standard"
                          placeholder="filter by"
                          value={selectedCategory}
                          onChange={(e) => setSelectedCategory(e.target.value)}
                          className={styles.selectField}
                          disableUnderline
                          IconComponent={KeyboardArrowDownIcon}
                          sx={{
                            "& .MuiSelect-icon": {
                              color: "black",
                              right: "15px",
                            },
                            "& .MuiSelect-select": {
                              paddingLeft: "5px",
                              marginRight: "15px",
                            },

                            // minWidth: "100px",
                            fontFamily: "Inter",
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                width: "200px",
                                marginTop: "14px",
                                borderRadius: "30px",
                                padding: "1rem",
                              },
                            },
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                          }}
                        >
                          <MenuItem
                            value="All"
                            sx={{
                              fontFamily: "Inter",
                              fontSize: "16px",
                              fontWeight: 500,
                              letterSpacing: "-0.5px",
                              textAlign: "left",
                              lineHeight: "24px",
                              "&.MuiMenuItem-root": {
                                borderBottom: "1px solid #F4F4F4",
                              },
                            }}
                            divider
                          >
                            All
                          </MenuItem>

                          {blogsListByCategory?.map((category, index) => (
                            <MenuItem
                              key={index}
                              value={category?.name}
                              sx={{
                                fontFamily: "Inter",
                                fontSize: "16px",
                                fontWeight: 500,
                                letterSpacing: "-0.5px",
                                textAlign: "left",
                                lineHeight: "24px",
                                "&.MuiMenuItem-root": {
                                  borderBottom: "1px solid #F4F4F4",
                                },
                              }}
                              divider
                            >
                              {category?.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </Grid>

                    <Grid
                      size={{ sm: 6, md: 4, lg: 4 }}
                      className={styles.filterField}
                      mb={3}
                    >
                      <Select
                        variant="standard"
                        placeholder="filter by"
                        value={filterBy}
                        onChange={(e) => setFilterBy(e.target.value)}
                        disableUnderline
                        IconComponent={KeyboardArrowDownIcon}
                        sx={{
                          "& .MuiSelect-icon": {
                            color: "black",
                            right: "15px",
                          },
                          fontFamily: "inter",
                          minWidth: "100px",
                          textAlign: "left",
                          fontWeight: 500,
                          color: "rgba(35, 36, 37, 1)",
                          fontSize: "16px",
                          letterSpacing: "-0.005em",
                          "&.MuiMenuItem-root": {
                            borderBottom: "1px solid #F4F4F4",
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              marginTop: "14px",
                              borderRadius: "30px",
                              padding: "1rem",
                            },
                          },
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                        }}
                      >
                        <MenuItem
                          style={{ width: "200px" }}
                          value="Recent"
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "16px",
                            fontWeight: 500,
                            letterSpacing: "-0.5px",
                            textAlign: "left",
                            lineHeight: "24px",
                            "&.MuiMenuItem-root": {
                              borderBottom: "1px solid #F4F4F4",
                            },
                          }}
                          divider
                        >
                          Recent
                        </MenuItem>
                        <MenuItem
                          value="Popular"
                          sx={{
                            fontFamily: "Inter",
                            fontSize: "16px",
                            fontWeight: 500,
                            letterSpacing: "-0.5px",
                            textAlign: "left",
                            lineHeight: "24px",
                            "&.MuiMenuItem-root": {
                              borderBottom: "1px solid #F4F4F4",
                            },
                          }}
                          divider
                        >
                          Popular
                        </MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                ) : null}

                {blogList?.length ? (
                  <div style={{ marginTop: "20px" }}>
                    <Grid container spacing={"24px"} columnGap={"24px"}>
                      {blogList?.map((blog, index) => (
                        <Grid
                          size={{ sm: 12, md: 6, lg: 6 }}
                          key={index}
                          ref={
                            index === blogList?.length - 2
                              ? blogListScrollRef
                              : null
                          }
                        >
                          <CustomCarousel
                            carouselType={"blogList"}
                            blogDetails={{
                              images: blog?.media,
                              title: blog?.title,
                              author:
                                !!blog?.author?.name &&
                                blog?.publishedAt &&
                                `${blog?.author?.name} ${
                                  blog?.publishedAt &&
                                  ` / ${DateFormatter(blog?.publishedAt)}`
                                } `,
                            }}
                            onClick={() => handleNavigateToDetails(blog.slug)}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                ) : !blogList?.length && !isBlogListLoading ? (
                  <Box
                    mt={10}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    No Data
                  </Box>
                ) : null}

                {isBlogListLoading && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "1rem",
                      alignItems: "center",
                      height: blogList?.length ? "138px" : "300px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#151617" }} />
                  </Box>
                )}
              </div>

              {blogListPagination?.total > blogPageSize &&
                !isBlogListLoading && (
                  <Stack
                    alignItems={"center"}
                    mt={isSmallScreen ? 1 : 5}
                    mb={isSmallScreen ? 2.5 : 0}
                  >
                    {blogListPageSize >= blogListPagination?.total ? (
                      <button
                        className={styles.showMoreBtn}
                        onClick={handleViewLessBlogs}
                      >
                        View Less
                      </button>
                    ) : (
                      <button
                        className={styles.showMoreBtn}
                        onClick={() =>
                          setBlogListPageSize((prev) => prev + blogPageSize)
                        }
                      >
                        View More
                      </button>
                    )}
                  </Stack>
                )}
            </div>
          </div>

          {/* Updates */}
          {/* {blogListForUpdates?.length > 0 ? (
            <div className={styles.updatesSection}>
              <div className={styles.updateContent}>
                <div className={styles.updateHeader}>
                  <p>Updates</p>

                  <div className={styles.updatesControlIcons}>
                    <button
                      onClick={() => setUpdatesCurrentPage((prev) => prev - 1)}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        opacity: updatesCurrentPage === 1 ? 0.5 : 1,
                        cursor: updatesCurrentPage === 1 ? "text" : "pointer",
                      }}
                      disabled={updatesCurrentPage === 1}
                    >
                      <Image
                        className={styles.leftIcon}
                        src={RightIcon.src}
                        alt={"Left Icon"}
                        width={20}
                        height={20}
                      />
                    </button>

                    <button
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        cursor:
                          updatesCurrentPage >=
                          blogListForUpdatesPagination?.pageCount
                            ? "text"
                            : "pointer",
                        opacity:
                          updatesCurrentPage >=
                          blogListForUpdatesPagination?.pageCount
                            ? 0.5
                            : 1,
                      }}
                      onClick={() => {
                        setUpdatesCurrentPage((prev) => prev + 1);
                      }}
                      disabled={
                        updatesCurrentPage >=
                        blogListForUpdatesPagination?.pageCount
                      }
                    >
                      <Image
                        className={styles.rightIcon}
                        src={RightIcon.src}
                        alt={"Left Icon"}
                        width={20}
                        height={20}
                      />
                    </button>
                  </div>
                </div>

                {isUpdateBlogListLoading ? (
                  <Stack my={5} direction={"row"} justifyContent={"center"}>
                    <CircularProgress sx={{ color: "#939393" }} />
                  </Stack>
                ) : (
                  <Box>
                    {blogListForUpdates?.length &&
                      blogListForUpdates?.map((blog, index) => (
                        <MostReadCard
                          key={index}
                          image={blog?.media[0]?.url}
                          researchDetails={
                            !!blog?.author?.name &&
                            blog?.publishedAt &&
                            `${blog?.author?.name} ${
                              blog?.publishedAt &&
                              ` / ${DateFormatter(blog?.publishedAt)}`
                            } `
                          }
                          title={blog?.title}
                          description={blog?.short_description}
                          theme={"light"}
                          onClick={() => handleNavigateToDetails(blog?.slug)}
                        />
                      ))}
                  </Box>
                )}
              </div>
            </div>
          ) : null} */}
        </>
      )}
    </BlogsLayout>
  );
};

export default Blogs;
